export default __webpack_public_path__ + "static/media/warpage_2.d94cd0cf.png";